import { render, staticRenderFns } from "./DormCreate.vue?vue&type=template&id=b96389a2&"
import script from "./DormCreate.vue?vue&type=script&lang=js&"
export * from "./DormCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports